import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=181d5445&scoped=true"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"
import style0 from "./createUser.vue?vue&type=style&index=0&id=181d5445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d5445",
  null
  
)

export default component.exports